const gameQueriesKeysMap = [
  ['g_name', 'name'],
  ['g_id', 'id'],
  ['g_device', 'device'],
  ['g_providerName', 'providerName'],
  ['g_mode', 'gameMode'],
  ['g_type', 'gameType'],
  ['g_inFreeSpinState', 'inFreeSpinState'],
  ['g_launchId', 'launchId'],
  ['g_maintenance', 'maintenance'],
  ['g_productId', 'productId'],
  ['g_status', 'status'],
];

export const addGameSearchParams = (
  searchParams: URLSearchParams,
  setQueryParams: (params: URLSearchParams, options?: { replace?: boolean }) => void,
  props: any,
  replace = false
): void => {
  removeGameSearchParams(searchParams);

  gameQueriesKeysMap.forEach(([key, mapKey]) => {
    const value = props[mapKey];
    if (!value) return;
    searchParams.append(key, value);
  });

  setQueryParams(searchParams, { replace });
};

export const getGameSearchParams = (
  searchParams: URLSearchParams
): { gameData: Record<string, string>; isEmpty: boolean } => {
  let isEmpty = true;

  const gameData = gameQueriesKeysMap.reduce((aggregator, [key, mapKey]) => {
    const value = searchParams.get(key);
    if (value) {
      isEmpty = false;
      return { ...aggregator, [mapKey]: value };
    }

    return aggregator;
  }, {});

  return { gameData, isEmpty };
};

export const checkForGameSearchParams = (searchParams: URLSearchParams): boolean => {
  return !!searchParams.get('g_id');
};

export const removeGameSearchParams = (searchParams: URLSearchParams): void => {
  gameQueriesKeysMap.forEach(([key]) => {
    searchParams.get(key) && searchParams.delete(key);
  });
};
